module.exports = __webpack_public_path__ + "img/diamonds-with.98e6c33.jpg";